// extracted by mini-css-extract-plugin
export default {"Modal":"Style_Modal__k9xDd","Cont":"Style_Cont__s4z6h"};